import { createAction, props } from '@ngrx/store';
import { Paginator } from 'src/app/shared/models/grid.model';

export const InitAddStore = createAction(
  '[Store Management: Add Store]: Init Add Store',
  props<{
    displayedColumns: { [key: string]: string };
    displayProperty: string;
    title: string;
    selectedItemsText: string;
    searchText: string;
    selectedItems: any;
  }>(),
);

export const SearchFieldChanged = createAction(
  '[Store Management: Add Store]: Search Field Changed',
  props<{ searchFilter: string }>(),
);

export const AddItem = createAction(
  '[Store Management: Add Store]: Add Item',
  props<{ item: any }>(),
);

export const RemoveItem = createAction(
  '[Store Management: Add Store]: Remove Item',
  props<{ item: any }>(),
);

export const PagingChanged = createAction(
  '[Store Management: Add Store]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

export const SelectNone = createAction('[Store Management: Add Store]: Select None');

export const SelectAll = createAction('[Store Management: Add Store]: Select All');

export const SaveStoreData = createAction('[Store Management: Add Store]: Save Store Data');

export const SaveStoreGroups = createAction(
  '[Store Management: Add Store]: Save Store Groups',
  props<{ storeGroups: any }>(),
);

export const SaveClubs = createAction(
  '[Store Management: Add Store]: Save Clubs',
  props<{ clubs: any }>(),
);

export const SaveBrands = createAction(
  '[Store Management: Add Store]: Save Brands',
  props<{ brands: any }>(),
);

export const SaveCouponSets = createAction(
  '[Store Management: Add Store]: Save Couponsets',
  props<{ couponSets: any }>(),
);

export const SaveUsers = createAction(
  '[Store Management: Add Store]: Save Users',
  props<{ users: any }>(),
);
